import { spaceBoxWidth } from "./spaceVars";

// Cannot use class as IMMER LIBRARY in REDUX does not detect changes in class objects
// for some fkn reason
export function createGraphicPerson(
  admin,
  avatar_key,
  family_name,
  given_name,
  micOn = false,
  camOn = false,
  share = false,
  luid,
  muted,
  shout,
  pinnedShare,
  shoutable,
  locked,
  focus,
  buzzed,
  uuid,
  x,
  y
) {
  // ID
  return {
    luid: luid,
    uuid: uuid,
    // Person Details
    admin: admin,
    avatar_key: avatar_key,
    family_name: family_name,
    given_name: given_name,
    // Device Status
    micOn: micOn,
    camOn: camOn,
    share: share,
    muted: muted,
    shout: shout,
    pinnedShare: pinnedShare,
    // Person Status
    shoutable: shoutable,
    locked: locked,
    focus: focus,
    buzzed: buzzed,
    // Positioning
    x: x,
    y: y,
    d2me: spaceBoxWidth * 2,
    inRange: false,
    time: null,
  };
}
